import { useEffect } from 'react';

import { getElectronAPI } from 'src/hooks/useElectron';
import { useShell } from 'src/legacy/components/Layout/AppShell/ShellContext';

/**
 * Syncs sidebar state between the webapp and the Electron chrome bar.
 * Listens for toggle commands from the chrome bar and reports state changes back.
 */
export const useElectronSidebar = () => {
  const {
    isDesktopSidebarCollapsed,
    toggleDesktopSidebar,
    isResizableSidebarActive,
  } = useShell();

  // Listen for toggle commands from the chrome bar
  useEffect(() => {
    const api = getElectronAPI();
    if (!api) return;
    return api.onSidebarToggle(toggleDesktopSidebar);
  }, [toggleDesktopSidebar]);

  // Report sidebar collapsed state to the chrome bar
  useEffect(() => {
    getElectronAPI()?.reportSidebarState(isDesktopSidebarCollapsed);
  }, [isDesktopSidebarCollapsed]);

  // Report whether the sidebar feature is active
  useEffect(() => {
    getElectronAPI()?.reportSidebarFeatureActive(isResizableSidebarActive);
  }, [isResizableSidebarActive]);
};
